import React, { type FC } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import { Box, xcss } from '@atlaskit/primitives';
import QuestionCircleIcon from '@atlaskit/icon/core/question-circle';
import { LinkIconButton } from '@atlaskit/button/new';

const marginLeftStyle = xcss({ marginLeft: 'auto' });
const i18n = defineMessages({
	buttonLabel: {
		id: 'confluence-analytics.help-and-support.label',
		defaultMessage: 'Help and Support',
		description: 'The text shown as the tooltip/label of the help and support button',
	},
});
export const HelpAndSupport: FC = () => (
	<Box xcss={marginLeftStyle}>
		<LinkIconButton
			href="https://confluence.atlassian.com/x/ZJ30OQ"
			icon={QuestionCircleIcon}
			label={<FormattedMessage {...i18n.buttonLabel} />}
			isTooltipDisabled={false}
			target="_blank"
			rel="noopener noreferrer"
			appearance="subtle"
		/>
	</Box>
);
